import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import store from "./store";
import zero from "./plugins/zero";
import Toasted from 'vue-toasted';
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs);
Vue.use(Toasted);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);
Vue.use(VeeValidate, { fieldsBagName: "veeFields" });
Validator.localize("es", es);
Vue.prototype.$zero = zero;

new Vue({
	el: "#app",
	router,
	store,
	icons,
	template: "<App/>",
	components: {
		App
	}
});
